var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-3",attrs:{"id":"not-found"}},[_c('h4',[_vm._v("The content you are looking for cannot be found or doesn't exist.")])])}]

export { render, staticRenderFns }